/** Curated editorial search suggestions for the search overlay (mockup's "Trending searches"). */
export const SEARCH_TERMS = [
  'Hyaluronic acid',
  'Shea butter',
  'SPF 50',
  'Lip tint',
  'Fragrance',
  'Hair oil',
] as const;
